import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Paper, TextField } from "@mui/material";
import { FaPlusCircle } from "react-icons/fa";
import { Editor } from "@tinymce/tinymce-react";
import { server, tinyApiKey } from "../../server";
import MyButton from "../../Components/global/MyButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import PageName from "../../Components/global/PageName";

export default function AddNewDoc() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [content, setContent] = useState("");

  const handleAddDoc = async (data) => {
    try {
      const { data: resData } = await axios.post(
        `${server}/docs/new`,
        content.toString() || "",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          params: {
            title: data?.title,
            coverImageUrl: "",
            category: data?.category,
          },
        }
      );
      toast.success(resData?.message);
      reset();
      setContent("");
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

  return (
    <div className="">
      <PageName title="Add New Document" />

      <Paper
        sx={{ p: 2, mt: 2, borderRadius: 2 }}
        className="border border-gray-300"
      >
        <div className="text-xl font-semibold text-gray-700">
          Fill the form to add new document
        </div>

        <form onSubmit={handleSubmit(handleAddDoc)} className="mt-6 space-y-6">
          {/* Document Title */}
          <TextField
            fullWidth
            label="Document Title"
            variant="outlined"
            {...register("title", { required: "Title is required" })}
            error={!!errors.title}
            helperText={errors.title?.message}
          />

          {/* Blog Content - TinyMCE */}
          <Editor
            apiKey={tinyApiKey}
            init={{
              height: 600,
              menubar: true,
              plugins:
                "advlist autolink lists link image charmap print preview anchor " +
                "searchreplace visualblocks code fullscreen " +
                "insertdatetime media table paste code help wordcount",
              toolbar:
                "undo redo | formatselect | bold italic underline strikethrough | " +
                "alignleft aligncenter alignright alignjustify | " +
                "bullist numlist outdent indent | " +
                "link image media table | " +
                "forecolor backcolor removeformat | " +
                "charmap fullscreen preview code help",
              image_advtab: true,
              content_style:
                "body { font-family:Arial, sans-serif; font-size:14px }",
            }}
            value={content}
            onEditorChange={(content) => setContent(content)}
          />

          {errors.content && (
            <p className="text-red-500 text-sm">{errors.content.message}</p>
          )}

          {/* Blog Category */}
          <TextField
            fullWidth
            label="Category"
            variant="outlined"
            {...register("category", { required: "Category is required" })}
            error={!!errors.category}
            helperText={errors.category?.message}
          />
          {/* Buttons */}
          <div className="flex items-center justify-end gap-6">
            <MyButton
              variant="outline"
              type="button"
              onClick={() => navigate(-1)}
            >
              CANCEL
            </MyButton>

            <MyButton type="submit">SUBMIT</MyButton>
          </div>
        </form>
      </Paper>
    </div>
  );
}
